import { bootShopFromLocation } from './utils/shopSpeed';
import React from 'react'; 
import ReactDOM from 'react-dom/client';
import './index.css';
import './components/marketplace.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initAnalytics } from './utils/analytics';

bootShopFromLocation();

initAnalytics();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode> 
    <App />
  </React.StrictMode>
);

reportWebVitals();
